import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { useQuery, useRouter } from '../../hooks';
import { DIGITAL_DOCUMENT } from '../../graphql/queries/digitalDocument';
import { Loader } from '@ets-global/b2c-website-ui';
import NotFoundHandler from '../../components/NotFoundHandler';
import HeaderMeta from '../../components/HeaderMeta';
import {
  BCDIPLOMA_LINKEDIN_QUERY,
  BCDIPLOMA_RENDER_URL,
  BCDIPLOMA_TWITTER_QUERY,
} from '../../constants';

import './styles.scss';

const Badge = () => {
  const {
    currentRoute: {
      params: { digitalDocumentKey },
    },
  } = useRouter();

  const { t } = useTranslation();
  const {
    loading,
    data: { digitalScoreReportURL },
  } = useQuery(DIGITAL_DOCUMENT, { variables: { digitalDocumentKey } });

  return (
    <>
      <HeaderMeta
        meta={{
          title: t('digital-score-reports.meta.title'),
          description: t('digital-score-reports.meta.title'),
        }}
      />
      {digitalScoreReportURL && (
        <Helmet>
          <meta
            hid="linkedin"
            name="image"
            property="og:image"
            content={`${BCDIPLOMA_RENDER_URL}/${digitalScoreReportURL}?${BCDIPLOMA_LINKEDIN_QUERY}`}
          />
          <meta
            hid="twitter"
            name="image"
            property="og:image"
            content={`${BCDIPLOMA_RENDER_URL}/${digitalScoreReportURL}?${BCDIPLOMA_TWITTER_QUERY}`}
          />
          <meta
            name="twitter:image"
            content={`${BCDIPLOMA_RENDER_URL}/${digitalScoreReportURL}?${BCDIPLOMA_TWITTER_QUERY}`}
          />
        </Helmet>
      )}
      {!loading && !digitalScoreReportURL && <NotFoundHandler />}
      {!loading && digitalScoreReportURL && (
        <iframe
          src={digitalScoreReportURL}
          frameBorder="0"
          allowFullScreen={true}
          title={t('digital-score-reports.meta.title')}
        />
      )}
      {loading && <Loader />}
    </>
  );
};

export default Badge;
